/**
 * ![lime 50](https://mui.com/static/colors-preview/lime-50-24x24.png) ![lime 100](https://mui.com/static/colors-preview/lime-100-24x24.png) ![lime 200](https://mui.com/static/colors-preview/lime-200-24x24.png) ![lime 300](https://mui.com/static/colors-preview/lime-300-24x24.png) ![lime 400](https://mui.com/static/colors-preview/lime-400-24x24.png) ![lime 500](https://mui.com/static/colors-preview/lime-500-24x24.png) ![lime 600](https://mui.com/static/colors-preview/lime-600-24x24.png) ![lime 700](https://mui.com/static/colors-preview/lime-700-24x24.png) ![lime 800](https://mui.com/static/colors-preview/lime-800-24x24.png) ![lime 900](https://mui.com/static/colors-preview/lime-900-24x24.png) ![lime A100](https://mui.com/static/colors-preview/lime-A100-24x24.png) ![lime A200](https://mui.com/static/colors-preview/lime-A200-24x24.png) ![lime A400](https://mui.com/static/colors-preview/lime-A400-24x24.png) ![lime A700](https://mui.com/static/colors-preview/lime-A700-24x24.png)
 */
const lime = {
  /**
   * Preview: ![lime 50](https://mui.com/static/colors-preview/lime-50-24x24.png)
   */
  50: '#f9fbe7',
  /**
   * Preview: ![lime 100](https://mui.com/static/colors-preview/lime-100-24x24.png)
   */
  100: '#f0f4c3',
  /**
   * Preview: ![lime 200](https://mui.com/static/colors-preview/lime-200-24x24.png)
   */
  200: '#e6ee9c',
  /**
   * Preview: ![lime 300](https://mui.com/static/colors-preview/lime-300-24x24.png)
   */
  300: '#dce775',
  /**
   * Preview: ![lime 400](https://mui.com/static/colors-preview/lime-400-24x24.png)
   */
  400: '#d4e157',
  /**
   * Preview: ![lime 500](https://mui.com/static/colors-preview/lime-500-24x24.png)
   */
  500: '#cddc39',
  /**
   * Preview: ![lime 600](https://mui.com/static/colors-preview/lime-600-24x24.png)
   */
  600: '#c0ca33',
  /**
   * Preview: ![lime 700](https://mui.com/static/colors-preview/lime-700-24x24.png)
   */
  700: '#afb42b',
  /**
   * Preview: ![lime 800](https://mui.com/static/colors-preview/lime-800-24x24.png)
   */
  800: '#9e9d24',
  /**
   * Preview: ![lime 900](https://mui.com/static/colors-preview/lime-900-24x24.png)
   */
  900: '#827717',
  /**
   * Preview: ![lime A100](https://mui.com/static/colors-preview/lime-A100-24x24.png)
   */
  A100: '#f4ff81',
  /**
   * Preview: ![lime A200](https://mui.com/static/colors-preview/lime-A200-24x24.png)
   */
  A200: '#eeff41',
  /**
   * Preview: ![lime A400](https://mui.com/static/colors-preview/lime-A400-24x24.png)
   */
  A400: '#c6ff00',
  /**
   * Preview: ![lime A700](https://mui.com/static/colors-preview/lime-A700-24x24.png)
   */
  A700: '#aeea00',
} as const;

export default lime;
